import React, { useState } from 'react';
import { Mail, Phone, MapPin, Send } from 'lucide-react';
import { toast } from 'sonner';

const Contact = () => {
  const [formData, setFormData] = useState({ nom: '', email: '', telephone: '', sujet: '', message: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Contact form submitted:', formData);

    // Send to backend
    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    
    fetch(`${BACKEND_URL}/api/contacts`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          toast.success('Votre message a été envoyé avec succès ! Nous vous répondrons dans les plus brefs délais.');
          setFormData({ nom: '', email: '', telephone: '', sujet: '', message: '' });
        } else {
          toast.error('Erreur lors de l envoi du message');
        }
      })
      .catch(error => {
        console.error('Error:', error);
        toast.error('Erreur lors de l envoi du message');
      });
  };

  return (
    <div style={{ background: 'var(--bg-page)', minHeight: '100vh' }}>
      <section style={{ paddingTop: '140px', paddingBottom: '64px' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '48px' }}>
            <h1 className="display-medium" style={{ color: 'var(--text-primary)', marginBottom: '16px' }}>
              Contactez-Nous
            </h1>
            <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '700px', margin: '0 auto' }}>
              Une question ? Un projet ? Notre équipe d experts est à votre écoute pour vous accompagner dans votre transition énergétique.
            </p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '48px', maxWidth: '1200px', margin: '0 auto' }}>
            {/* Contact Info */}
            <div>
              <div className="network-card" style={{ marginBottom: '24px' }}>
                <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: 'var(--brand-primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '16px' }}>
                  <Phone size={24} style={{ color: 'var(--brand-dark)' }} />
                </div>
                <h3 className="heading-3" style={{ color: 'var(--text-primary)', marginBottom: '8px' }}>Téléphone</h3>
                <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>01 75 43 85 80</p>
                <p className="body-small" style={{ color: 'var(--text-light)', marginTop: '8px' }}>Du lundi au vendredi, 9h-18h</p>
              </div>

              <div className="network-card" style={{ marginBottom: '24px' }}>
                <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: 'var(--brand-primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '16px' }}>
                  <Mail size={24} style={{ color: 'var(--brand-dark)' }} />
                </div>
                <h3 className="heading-3" style={{ color: 'var(--text-primary)', marginBottom: '8px' }}>Email</h3>
                <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>contact@nvdepart.fr</p>
                <p className="body-small" style={{ color: 'var(--text-light)', marginTop: '8px' }}>Réponse sous 24h</p>
              </div>

              <div className="network-card">
                <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: 'var(--brand-primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '16px' }}>
                  <MapPin size={24} style={{ color: 'var(--brand-dark)' }} />
                </div>
                <h3 className="heading-3" style={{ color: 'var(--text-primary)', marginBottom: '8px' }}>Adresse</h3>
                <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>27 Avenue Viel<br />75017 Paris, France</p>
              </div>
            </div>

            {/* Contact Form */}
            <div>
              <div className="network-card" style={{ padding: 'var(--spacing-giant)' }}>
                <h2 className="heading-2" style={{ color: 'var(--text-primary)', marginBottom: '24px' }}>
                  Envoyez-nous un message
                </h2>

                <form onSubmit={handleSubmit}>
                  <div style={{ marginBottom: '24px' }}>
                    <label style={{ display: 'block', marginBottom: '8px', fontSize: '16px', fontWeight: '500', color: 'var(--text-primary)' }}>
                      Nom complet <span style={{ color: 'red' }}>*</span>
                    </label>
                    <input
                      type="text"
                      value={formData.nom}
                      onChange={(e) => setFormData({...formData, nom: e.target.value})}
                      placeholder="Votre nom"
                      required
                      style={{ width: '100%', padding: '12px 16px', border: '2px solid var(--border-light)', borderRadius: '12px', fontSize: '16px', outline: 'none' }}
                    />
                  </div>

                  <div style={{ marginBottom: '24px' }}>
                    <label style={{ display: 'block', marginBottom: '8px', fontSize: '16px', fontWeight: '500', color: 'var(--text-primary)' }}>
                      Email <span style={{ color: 'red' }}>*</span>
                    </label>
                    <input
                      type="email"
                      value={formData.email}
                      onChange={(e) => setFormData({...formData, email: e.target.value})}
                      placeholder="votre@email.fr"
                      required
                      style={{ width: '100%', padding: '12px 16px', border: '2px solid var(--border-light)', borderRadius: '12px', fontSize: '16px', outline: 'none' }}
                    />
                  </div>

                  <div style={{ marginBottom: '24px' }}>
                    <label style={{ display: 'block', marginBottom: '8px', fontSize: '16px', fontWeight: '500', color: 'var(--text-primary)' }}>
                      Sujet <span style={{ color: 'red' }}>*</span>
                    </label>
                    <input
                      type="text"
                      value={formData.sujet}
                      onChange={(e) => setFormData({...formData, sujet: e.target.value})}
                      placeholder="Sujet de votre demande"
                      required
                      style={{ width: '100%', padding: '12px 16px', border: '2px solid var(--border-light)', borderRadius: '12px', fontSize: '16px', outline: 'none' }}
                    />
                  </div>

                  <div style={{ marginBottom: '24px' }}>
                    <label style={{ display: 'block', marginBottom: '8px', fontSize: '16px', fontWeight: '500', color: 'var(--text-primary)' }}>
                      Message <span style={{ color: 'red' }}>*</span>
                    </label>
                    <textarea
                      value={formData.message}
                      onChange={(e) => setFormData({...formData, message: e.target.value})}
                      placeholder="Décrivez votre projet ou votre demande..."
                      rows="6"
                      required
                      style={{ width: '100%', padding: '12px 16px', border: '2px solid var(--border-light)', borderRadius: '12px', fontSize: '16px', outline: 'none', resize: 'vertical', fontFamily: 'inherit' }}
                    />
                  </div>

                  <button type="submit" className="btn-primary" style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                    Envoyer le message
                    <Send size={20} />
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
